import { connect } from "react-redux";
import { reduxForm, SubmissionError } from "redux-form";

import { updateUser } from "../constants/actions";
import UserForm from "../components/forms/UserForm";

const onSubmit = (values, dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateUser({ values, resolve, reject }));
  }).catch(error => {
    throw new SubmissionError({ _error: error });
  });
};

const mapStateToProps = state => ({
  initialValues: state.user
});

const Form = reduxForm({
  form: "user",
  enableReinitialize: true,
  onSubmit
})(UserForm);

export default connect(mapStateToProps)(Form);



// WEBPACK FOOTER //
// ./src/containers/UserForm.js